import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

export default function PaymentResult({ type }) {
  const [params] = useSearchParams();
  const sessionId = params.get("ref") || params.get("preapproval_id") || params.get("session_id");
  const [status, setStatus] = useState("verificando");
  const { refresh } = useAuth();

  useEffect(() => {
    if (type !== "success" || !sessionId) return;
    let tries = 0;
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus("pago");
          refresh();
          return;
        }
      } catch {}
      tries += 1;
      if (tries < 15) timer = setTimeout(poll, 2000);
      else setStatus("pendente");
    };
    poll();
    return () => clearTimeout(timer);
  }, [sessionId, type]);

  if (type === "cancel") {
    return (
      <div className="max-w-md mx-auto py-16 text-center animate-in-up" data-testid="payment-cancel">
        <XCircle className="h-14 w-14 text-amber-500 mx-auto" />
        <h1 className="mt-4 text-2xl font-bold">Pagamento não concluído</h1>
        <p className="mt-2 text-slate-600">Nenhuma cobrança foi feita. Você pode tentar novamente quando quiser.</p>
        <Link to="/app/planos"><Button className="mt-6 h-12 bg-sky-600 hover:bg-sky-700 text-white" data-testid="back-plans-btn">Voltar aos planos</Button></Link>
      </div>
    );
  }

  return (
    <div className="max-w-md mx-auto py-16 text-center animate-in-up" data-testid="payment-success">
      {status === "pago" ? (
        <>
          <CheckCircle2 className="h-14 w-14 text-green-600 mx-auto" />
          <h1 className="mt-4 text-2xl font-bold">Assinatura ativada!</h1>
          <p className="mt-2 text-slate-600">Seu plano já está liberado. Obrigado por assinar o GEPR.</p>
        </>
      ) : (
        <>
          <div className="h-14 w-14 mx-auto rounded-full border-4 border-slate-200 border-t-sky-600 animate-spin" />
          <h1 className="mt-4 text-2xl font-bold">Confirmando pagamento...</h1>
          <p className="mt-2 text-slate-600">Isso leva alguns segundos.</p>
        </>
      )}
      <Link to="/app"><Button className="mt-6 h-12 bg-sky-600 hover:bg-sky-700 text-white" data-testid="go-dashboard-btn">Ir para o dashboard</Button></Link>
    </div>
  );
}
